/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { useUIDSeed } from 'react-uid';
import ReactHtmlParser from 'react-html-parser';
import {
    object, string, arrayOf, shape,
} from 'prop-types';

const PageHeading = ({
    classes, headingTitle, casketFlowers, standingFlowers, funeralService, friends, funeralHome, sendingFlowers, subText, sympathyGifts,
}) => {
    const seed = useUIDSeed();
    return (
        <div container className={classes.container}>
            <div className={classes.headingBlock}>
                <h1 className={classes.heading}>{headingTitle}</h1>
            </div>
            <div className={classes.headerImage}>
                <img className={classes.image} src="//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/sympathy/appropriate-funeral-flowers-symapathy-gifts.jpg" alt="pet" />
            </div>
            <p>{ReactHtmlParser(subText)}</p>
            {casketFlowers.map((list) => (
                <div key={seed(list)}>
                    <p className={classes.contentHeading}>{list.heading}</p>
                    <div className={classes.imageContainer}>
                        <img className={classes.casketFlowersImage} src={list.image} alt="casket_flower" />
                    </div>
                </div>
            ))}
            {standingFlowers.map((list) => (
                <div key={seed(list)}>
                    <p className={classes.contentHeading}>{list.heading}</p>
                    <div className={classes.imageContainer}>
                        <img className={classes.standingFlowersImage} src={list.image} alt="standing_flower" />
                    </div>
                </div>
            ))}
            {friends.map((list) => (
                <div key={seed(list)}>
                    <p className={classes.contentHeading}>{list.heading}</p>
                    <div className={classes.imageContainer}>
                        <img className={classes.friends} src={list.image} alt="friends" />
                    </div>
                </div>
            ))}
            {funeralHome.map((list) => (
                <div key={seed(list)}>
                    <p className={classes.contentHeading}>{list.heading}</p>
                    <p className={classes.content}>{list.sentenceOne}</p>
                    <p className={classes.content}>{list.sentenceTwo}</p>
                </div>
            ))}
            {sympathyGifts.map((list) => (
                <div key={seed(list)}>
                    <p className={classes.contentHeading}>{list.heading}</p>
                    <p className={classes.content}>{list.content}</p>
                    <p className={classes.content}>{ReactHtmlParser(list.contentNext)}</p>
                </div>
            ))}
            {funeralService.map((list) => (
                <div key={seed(list)}>
                    <h4 className={classes.contentHeading}>{list.heading}</h4>
                    <p className={classes.content}>{list.content}</p>
                </div>
            ))}
            {sendingFlowers.map((list) => (
                <div key={seed(list)}>
                    <h4 className={classes.contentHeading}>{list.heading}</h4>
                    <p className={classes.content}>{ReactHtmlParser(list.content)}</p>
                    <p className={classes.content}>{ReactHtmlParser(list.contentNext)}</p>
                </div>
            ))}
        </div>
    );
};

PageHeading.propTypes = {
    classes: object.isRequired,
    headingTitle: string.isRequired,
    subText: string.isRequired,
    casketFlowers: arrayOf(
        shape({
            type: string.isRequired,
        }),
    ).isRequired,
    standingFlowers: arrayOf(
        shape({
            type: string.isRequired,
        }),
    ).isRequired,
    funeralService: arrayOf(
        shape({
            type: string.isRequired,
        }),
    ).isRequired,
    friends: arrayOf(
        shape({
            type: string.isRequired,
        }),
    ).isRequired,
    funeralHome: arrayOf(
        shape({
            type: string.isRequired,
        }),
    ).isRequired,
    sendingFlowers: arrayOf(
        shape({
            type: string.isRequired,
        }),
    ).isRequired,
    sympathyGifts: arrayOf(
        shape({
            type: string.isRequired,
        }),
    ).isRequired,

};

export default PageHeading;
